"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { initTelemetry, trackPageview } from "@/lib/telemetry";

/**
 * Mounts once in the root layout: initializes Sentry + PostHog and captures
 * a pageview on every App Router navigation. Renders nothing.
 */
export function TelemetryProvider() {
  const pathname = usePathname();

  useEffect(() => {
    initTelemetry();
  }, []);

  useEffect(() => {
    if (pathname) trackPageview(pathname);
  }, [pathname]);

  return null;
}
